module.exports = __webpack_public_path__ + "img/sign-in-with-apple-logo-only.bdabc559.svg";